import type { ComponentProps } from 'react';

import { cn } from '@/shared/utils/cn';

export interface PageHeaderTitleProps extends ComponentProps<'span'> {}

export const PageHeaderTitle = (props: PageHeaderTitleProps) => {
  const { className, children, ...rest } = props;

  return (
    <span
      className={cn(
        'py-3 text-sm leading-none font-bold text-white',
        className,
      )}
      {...rest}
    >
      {children}
    </span>
  );
};
